import {LanguageShortCodeType} from "../types/language-short-code.type.ts";
import {LangTemplate} from "../template/LangTemplate.ts";
import {getCurrentLang} from "../utils.ts";

class Lang {
	name: string
	shortCode: LanguageShortCodeType
	template: LangTemplate
	render () {
		return this.template.getHtml(this.name, this.shortCode, getCurrentLang())
	}
}
export {Lang}
